//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
let d=[[],[[[],"GetAlignVector",{R_:{alignVector:''}},0,0],[["alignVector"],"SetAlignVector",{},1,0],[[],"GetReferenceDiameter",{R_:{referenceDiameter:''}},0,0],[["referenceDiameter"],"SetReferenceDiameter",{},1,0],[[],"GetOffset",{R_:{offset:''}},0,0],[["offset"],"SetOffset",{},1,0],[[],"GetSeedCsys",{R_:{seedCsys:"CoordinateSystem"}},0,0],[["seedCsys"],"SetSeedCsys",{},1,0],[[],"GetOffsetCsys",{R_:{offsetCsys:"CoordinateSystem"}},0,0],[["offsetCsys"],"SetOffsetCsys",{},1,0],[["nCsys"],"GetCsys",{R_:{csys:"CoordinateSystem[]"}},0,0],[["edges"],"RemoveEdges",{},1,0],[["edges"],"SetEdges",{},1,0],[["csys"],"SetCsys",{},1,0],[[],"UpdateOffsetCsys",{},0,0]],[]];
SPLM.Tooling.QuickDatumCsysBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.QuickDatumCsysBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.QuickDatumCsysBuilder.AlignVectors = Object.freeze({
    "X" : "X", "NegativeX" : "NegativeX", "Y" : "Y", "NegativeY" : "NegativeY", "Z" : "Z", "NegativeZ" : "NegativeZ"});

export default SPLM;